import { useCallback } from "react";
import usePrefetchBundles from "./usePrefetchBundles";
import usePrefetchQueries from "./usePrefetchQueries";
export default function usePrefetchConfig() {
    const prefetchQueries = usePrefetchQueries();
    const prefetchBundles = usePrefetchBundles();
    return useCallback(function prefetchConfig(config, ...options) {
        var _options_, _options_1;
        const bundlesToPrefetch = getBundlesToPrefetchFromConfig(config);
        const queriesToPrefetch = getQueriesToPrefetchFromConfig(config);
        const promiseQueries = ((_options_ = options[0]) === null || _options_ === void 0 ? void 0 : _options_.skipQueries) || arePrefetchQueriesEmpty(queriesToPrefetch) ? Promise.resolve(Object.keys(queriesToPrefetch !== null && queriesToPrefetch !== void 0 ? queriesToPrefetch : {}).reduce((output, group)=>Object.assign(output, {
                [group]: []
            }), {})) : prefetchQueries(queriesToPrefetch, options[0]);
        const promiseBundles = ((_options_1 = options[0]) === null || _options_1 === void 0 ? void 0 : _options_1.skipBundles) ? Promise.resolve([]) : prefetchBundles([
            ...bundlesToPrefetch
        ]);
        return Promise.all([
            promiseBundles,
            promiseQueries
        ]);
    }, [
        prefetchQueries,
        prefetchBundles
    ]);
}
function getBundlesToPrefetchFromConfig(config, output = new Set()) {
    if (config.options.load) {
        output.add(config.options.load);
    }
    if (config.options.prefetchConfigs) {
        for (const childConfig of config.options.prefetchConfigs){
            getBundlesToPrefetchFromConfig(childConfig, output);
        }
    }
    return output;
}
function getQueriesToPrefetchFromConfig(config, output = {}) {
    if (config.options.prefetchQueries) {
        const { prefetchQueries } = config.options;
        if (typeof prefetchQueries !== 'object') {
            return {};
        }
        for(const group in prefetchQueries){
            if (prefetchQueries.hasOwnProperty(group)) {
                var _output, _group;
                (_output = output)[_group = group] || (_output[_group] = []);
                prefetchQueries[group].forEach((query)=>{
                    output[group].push(query);
                });
            }
        }
    }
    if (config.options.prefetchConfigs) {
        for (const childConfig of config.options.prefetchConfigs){
            getQueriesToPrefetchFromConfig(childConfig, output);
        }
    }
    return output;
}
function arePrefetchQueriesEmpty(queries) {
    return typeof queries !== 'object' || Object.keys(queries).length === 0 || Object.values(queries).every((hooks)=>hooks.length === 0);
}

//# sourceMappingURL=usePrefetchConfig.js.map